// export const imagePlaceholder =
//   'https://raderain-cdn.sirv.com/Images/placeholders/image-not-found.png'

// commenting the above as sirv account is de-activated
// https://nuskin.atlassian.net/browse/BRW-3043

import imagePlaceholder from 'src/images/imageNotFound.png'

export { imagePlaceholder }
export const categoryImageUrl =
  'https://raderain-cdn.sirv.com/Images/placeholders/GenericBanner-desktop.png'
